import { useSearchParams } from 'react-router-dom';

export function useLang() {
    const [searchParams] = useSearchParams();
    const lang = searchParams.get('lang');
    return lang === 'en' ? 'en' : 'it';
}
